import { render, staticRenderFns } from "./Maquila.vue?vue&type=template&id=aa8b9568"
import script from "./Maquila.vue?vue&type=script&lang=js"
export * from "./Maquila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports